import { render, staticRenderFns } from "./BookInfo.vue?vue&type=template&id=7cff737d&scoped=true&"
import script from "./BookInfo.vue?vue&type=script&lang=js&"
export * from "./BookInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BookInfo.vue?vue&type=style&index=1&id=7cff737d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cff737d",
  null
  
)

export default component.exports